import { cn } from '@/lib/utils';
import { VariantProps, cva } from 'class-variance-authority';
import { Loader2 } from 'lucide-react';
import React, { ComponentProps } from 'react';

export const spinnerVariants = cva('flex-col items-center justify-center', {
  variants: { show: { true: 'flex', false: 'hidden' } },
  defaultVariants: { show: true },
});

export const loaderVariants = cva('animate-spin text-primary', {
  variants: { size: { extraSmall: 'size-4', small: 'size-6', medium: 'size-8', large: 'size-12' } },
  defaultVariants: { size: 'medium' },
});

type SpinnerContentProps = VariantProps<typeof spinnerVariants> &
  VariantProps<typeof loaderVariants> & {
    containerClassName?: string;
    className?: string;
    children?: React.ReactNode;
  } & ComponentProps<'span'>;

const Spinner = ({
  size,
  show,
  children,
  containerClassName,
  className,
  ...rest
}: SpinnerContentProps) => {
  return (
    <span className={cn(spinnerVariants({ show }), containerClassName)} {...rest}>
      <Loader2 className={cn(loaderVariants({ size }), className)} />
      {children}
    </span>
  );
};

export { Spinner };
